
/*
	window.current_discount : integer 
		1: global discount
		2: discount by item quotation
*/


const initQuotation = () => {

	$("#table-quotation").on("load", function() {
	})
	// calculate value when change any input
	$("#table-quotation").on("input", ".input-calc", function (e) {
		if (window.current_discount == 1) {
			calculateSum()
			calcTotal(true)
			calcTotal(false)
		} else {
			calculateSum(true)
			calcTotalByItem(true)
			calcTotalByItem(false)
		}
	});
	//calculate total value if change input global discount
	$('#quotation_discount').on("input", function () {
		calcTotal(true)
		calcTotal(false)
	})

	// event change select discount 
	$("#select-discount").on("change", function () {
		window.current_discount = $(this).val()
		showColumns()
		// if ($(this).val() == 1){
		//     calculateSum()
		//     calcTotal()
		// }else{
		//     calculateSum(true)
		//     calcByItem()
		// }
	})
}

//show or hidden column discount by item
const showColumns = () => {
	var action = window.current_discount == 1 ? "table-row" : "none";
	var action_inverse = window.current_discount == 1 ? "none" : "block";
	var input_global_discount = document.getElementById("table-input-discount")
	input_global_discount.style.display = action;
	input_global_discount.getElementsByTagName('input')[0].value = null;
	document.getElementById("header-discount-item").style.display = action_inverse;
	stateRowsDiscount(action_inverse);
	if (window.current_discount == 1) {
		document.getElementById("header-discount-item").style.display = "none";
		calculateSum()
		calcTotal(true)
		calcTotal(false)
	} else {
		calculateSum(true)
		calcTotalByItem(true)
		calcTotalByItem(false)
	}
}


/*operations by item
	params: item : boolean => true = discount by item
						   => false || undefined = global discount
*/
function calculateSum(item) {
	var tableQutation = $('#table-quotation');
	tableQutation.find('tr').each(function () {
		const tr = $(this).find('.input-quantity')
		if (tr.length > 0) {
			var sum = 0;
			const quantity = tr.val();
			const price = $(this).find('.input-price').val();
			const disc_item = $(this).find('.input-disc').val();
			if (!isNaN(quantity) && quantity.length != 0 && !isNaN(price) && price.length != 0) {
				if (!item) {
					sum = parseFloat(price * quantity)
				} else {
					var temp_value = parseFloat(price * quantity)
					var discount = (disc_item / 100) * temp_value;
					sum = temp_value - discount;
				}
			}

			$(this).find('.label-total-row').text(formatterMoney.format(sum.toFixed(0)));
			$(this).find('.input-total-row').val(sum.toFixed(0));
		}
	});
}

// calc total when input select is discount by item
function calcTotalByItem(include_optionals = true) {
	var tableQutation = $('#table-quotation');
	var discount = 0
	var subtotal = 0
	var subtotal_discount = 0;
	var total = 0
	tableQutation.find("tr").not('.hide').each(function () {
		const quantity = $(this).find('.input-quantity').val();
		const price = $(this).find('.input-price').val();
		const discount_tr = $(this).find('.input-total-row').val();
		var $typeQuotation = $(this).find(".type_quotation input");
		if (!include_optionals && $typeQuotation.val() === "optional") return; 
		if (!isNaN(quantity) && quantity.length != 0 && !isNaN(price) && price.length != 0) {
			subtotal += parseFloat(price * quantity);
		}
		if (!isNaN(discount_tr)) {
			subtotal_discount += parseFloat(discount_tr)
		}
	});

	/* tableQutation.find("tr").not('.hide').find(".input-total-row").each(function () {
		if (!isNaN($(this).val())) {
			subtotal_discount += parseFloat($(this).val());
		}
	}); */
	discount = subtotal - subtotal_discount;
	total = (subtotal - discount) * 0.19;

	$(`#subtotal-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format(subtotal));
	$(`#discount-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format(discount));
	$(`#subtotal-discount-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format(subtotal - discount));

	$(`#total-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format((subtotal + total) - discount));
	if(!include_optionals){
		$('#quotation_total').val((subtotal + total) - discount);
		$('#quotation_subtotal').val(subtotal);

	}
}

// calc total when input select is global discount
function calcTotal(include_optionals = true) {
    var tableQuotation = $('#table-quotation');
    var discount = 0;
    var subtotal = 0;
    var total = 0;
    
    tableQuotation.find("tr").not('.hide').each(function () {
        var $tr = $(this);
        var $inputTotalRow = $tr.find(".input-total-row");
        var $typeQuotation = $tr.find(".type_quotation input");
        if (!include_optionals && $typeQuotation.val() === "optional") return; 
        
        $inputTotalRow.each(function () {
            if (!isNaN($(this).val())) {
                subtotal += parseFloat($(this).val());
            }
        });
    });

    var discountPercentage = $('#quotation_discount').val();
    discount = (discountPercentage / 100) * subtotal;
    total = (subtotal - discount) * 0.19;

    $(`#subtotal-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format(subtotal));
    $(`#discount-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format(discount));
    $(`#subtotal-discount-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format(subtotal - discount));
    $(`#total-label${!include_optionals ? "-standart" : ""}`).text(formatterMoney.format((subtotal + total) - discount));
	if(!include_optionals){
		$('#quotation_total').val((subtotal + total) - discount);
		$('#quotation_subtotal').val(subtotal);
	}
}

// dynamic column discount table
/*
	action:string = "none" | "block"
	newRow:boolean = true => when insert new row add field discount
*/
function stateRowsDiscount(action, newRow) {
	var rows = document.getElementsByClassName("body-discount-item")
	for (var i = 0; i < rows.length; i++) {
		if (!newRow && rows[i].getElementsByTagName('input').length > 0) rows[i].getElementsByTagName('input')[0].value = null;
		rows[i].style.display = action;
	}
}


var formatterMoney = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 0,
	minimumFractionDigits: 0
});


export { initQuotation, calcTotal, calculateSum, calcTotalByItem, showColumns, stateRowsDiscount }


// Action text 6

require("trix")
require("@rails/actiontext")



